module.exports = __webpack_public_path__ + "static/media/associates_light.b9af472c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/associates_light.png
// module id = 3545
// module chunks = 3